import { Box } from '@chakra-ui/react'
import { ItList } from 'types/graphql'

import VimeoPlayer from 'src/components/widgets/VimeoPlayer/VimeoPlayer'
import YoutubePlayer from 'src/components/widgets/YoutubePlayer/YoutubePlayer'
import { SOCIAL_PROOF_REGEX } from 'src/lib/constants'
import { BrandColor } from 'src/types'

const SocialProofViewer: React.FC<{
  itList: ItList
  brandColor?: BrandColor
  locked: boolean
  isPreview: boolean
}> = ({ itList, brandColor, locked, isPreview }) => {
  const url = itList.socialProofUrl
  if (!locked || !url || !url.match(SOCIAL_PROOF_REGEX)) {
    return null
  }
  const isVimeo = url.includes('vimeo.com')
  return (
    <Box
      px={{ base: 4, lg: isPreview ? 4 : 24 }}
      id="it-list-item-featuredVideo"
    >
      <Box as="h4" className="thick" mt={12} mb={6}>
        Featured video
      </Box>
      <Box borderRadius={12} overflow="hidden">
        {isVimeo ? (
          <VimeoPlayer url={url} brandColor={brandColor} />
        ) : (
          <YoutubePlayer url={url} />
        )}
      </Box>
    </Box>
  )
}

export default SocialProofViewer
